module.exports = __webpack_public_path__ + "static/img/仓储车辆.0abf9dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/仓储车辆.jpg
// module id = i6ja
// module chunks = 1